import { Card, Chip, Grid, Stack, Tab } from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getCashRegisterService,
  getTransactionByCashRegisterService,
} from '@/services/cash-register';
import { useParams } from 'react-router-dom';
import { createElement, useEffect, useMemo, useState } from 'react';
import { currentFormat } from '@/utils/cases';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Loader from '@/commons/loader';
import { translates } from '@/utils/translate';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import CashRegisterTimeLine from '../components/time-line';
import { CardPay } from '../components/card-pay';
import BookingTotalIncomes from '../components/money-indicator';
import { CashRegisterClosePage } from '../components/close-cash';
import { CashRegisterCreatePage } from '../components/create-cash';
import LogCashRegister from '../components/log-cash-register';
import { TransactionModal } from '../components/transaction';
import DiferenceCashRegister from '../components/diference-cash-register';
import LogsPaymentMethodTimeLine from '../components/log-paymen-method-orders';
import LogsReOpenOrdersTimeLine from '../components/log-re-open-orders';
import LogsChangeTipsTimeLine from '../components/log-change-tips';
// import { HistoryOrder } from '../components/history-order';

export default function CashRegisterViewPage() {
  const [open, setOpen] = useState(false);
  const { isOpen } = useCashRegisterContext();
  const [value, setValue] = useState('1');
  const { isFoodCompany } = useCompanyCategory();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = (_value: string) => {
    setOpen(false);
  };

  const Component = useMemo(
    () =>
      createElement(isOpen ? CashRegisterClosePage : CashRegisterCreatePage, {
        open,
        onClose: handleClose,
        selectedValue: '',
      }),
    [open, isOpen]
  );

  const { id } = useParams();
  const { box } = useCashRegisterContext();
  const currentId = !id ? box?.id : id;

  const series = [
    { x: 2016, y: 111 },
    { x: 2017, y: 136 },
    { x: 2018, y: 76 },
    { x: 2019, y: 108 },
    { x: 2020, y: 74 },
    { x: 2021, y: 54 },
    { x: 2022, y: 57 },
    { x: 2023, y: 84 },
  ];

  const { mutate, data: cashRegister } = useMutation({
    mutationKey: ['cash-register', currentId],
    mutationFn: getCashRegisterService(currentId),
    onSuccess: (dataTemp: any) => {
      const {
        difference_creditCard: differenceCreditCard,
        difference_cash: differenceCash,
        difference_transference: differenceTransference,
      } = dataTemp;
      const difference = differenceCreditCard + differenceCash + differenceTransference;
      return {
        ...dataTemp,
        difference,
      };
    },
  });

  useEffect(() => {
    if (currentId?.length) {
      mutate();
    }
  }, [currentId, mutate]);
  const { isLoading: isLoading2, data: transactions } = useQuery({
    queryKey: ['transactions', 'findById', currentId],
    queryFn: getTransactionByCashRegisterService(currentId),
    select: (dataTemp) => {
      let deposit = 0;
      let withdrawal = 0;
      dataTemp.forEach((item: any) => {
        if (item.isWithdrawal) {
          withdrawal += Math.abs(item.cash);
        } else {
          deposit += item.cash;
        }
      });
      return {
        deposit,
        withdrawal,
        data: dataTemp,
      };
    },
  });

  const paymentMethods = useMemo(
    () => [
      {
        label: translates.cash,
        value: currentFormat(cashRegister?.cash),
        icon: 'fluent-mdl2:money',
        color:
          ' linear-gradient(303deg, rgba(91,228,144,0.6446953781512605) 0%, rgba(0,167,111,0.06206232492997199) 100%)',
      },
      {
        label: translates.creditCard,
        value: currentFormat(cashRegister?.creditCard),
        icon: 'circum:money-check-1',
        color:
          'linear-gradient(303deg, rgba(228,214,80,0.639093137254902) 0%, rgba(241,245,6,0.06206232492997199) 100%)',
      },
      {
        label: translates.transference,
        value: currentFormat(cashRegister?.transference),
        icon: 'fa6-solid:money-bill-transfer',
        color:
          'linear-gradient(303deg, rgba(97,243,240,0.6418942577030813) 0%, rgba(0,184,217,0.06206232492997199) 100%)',
      },
      {
        label: translates.retreat,
        value: currentFormat(transactions?.withdrawal),
        icon: 'vaadin:money-deposit',
        color:
          'linear-gradient(304deg, rgba(184,78,88,0.6403712296983759) 0%, rgba(36,21,68,0.06264501160092806) 100%)',
      },
      {
        label: translates.deposit,
        value: currentFormat(transactions?.deposit),
        icon: 'vaadin:money-withdraw',
        color:
          'linear-gradient(304deg, rgba(106,102,187,0.6403712296983759) 0%, rgba(36,21,68,0.06264501160092806) 100%)',
      },
    ],
    [
      cashRegister?.cash,
      cashRegister?.creditCard,
      cashRegister?.transference,
      transactions?.deposit,
      transactions?.withdrawal,
    ]
  );
  if (false || isLoading2) {
    return <Loader fullScreen />;
  }

  const logCash = cashRegister?.logsCashRegister;
  const CashDifference = cashRegister;

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <TabContext value={value}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Grid
            container
            justifyContent="space-around"
            spacing={{
              md: 1,
              sm: 2,
              xl: 4,
              xs: 1,
            }}
          >
            {paymentMethods?.map?.((item) => (
              <Grid
                item
                sm={2}
                md={2}
                xs={6}
                key={item.label}
                display="flex"
                justifyContent="center"
              >
                <CardPay
                  bgcolor={item.color}
                  label={item.label}
                  icon={item.icon}
                  value={item.value}
                />
              </Grid>
            ))}
            <Grid item xs={12} md={6}>
              <BookingTotalIncomes
                total={cashRegister?.initialCash ?? 0}
                title={translates.initialCash}
                chart={{
                  series,
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <BookingTotalIncomes
                total={cashRegister?.finalCash ?? 0}
                title={translates.finalCash}
                color="info"
                chart={{
                  series,
                }}
              />
            </Grid>
            {!logCash && <Grid item xs={0} md={2} />}
            <Grid item xs={12} md={logCash ? 6 : 8}>
              <BookingTotalIncomes
                total={logCash?.isOpen ? 0 : logCash?.difference ?? 0}
                title={translates.diference}
                isDiferent
                color={
                  // eslint-disable-next-line no-nested-ternary
                  (logCash?.isOpen ? 0 : logCash?.difference) < 0
                    ? 'error'
                    : (logCash?.isOpen ? 0 : logCash?.difference) === 0
                    ? 'success'
                    : 'warning'
                }
                chart={{
                  series,
                }}
              />
            </Grid>
            <Grid item xs={0} md={logCash ? 3 : 1}>
              {logCash && (
                <DiferenceCashRegister
                  isOpen={logCash?.isOpen}
                  title={translates.specificDifferences}
                  data={CashDifference}
                />
              )}
            </Grid>
            <Grid item xs={0} md={logCash ? 3 : 1}>
              {logCash && <LogCashRegister title={translates.dataEnteredClosing} data={logCash} />}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              height: '100%',
            }}
          >
            <Stack
              sx={{
                borderBottom: 1,
                borderColor: 'divider',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <TabList onChange={handleChange} aria-label="" sx={{ width: '100%' }}>
                <Tab label={translates.transactions} value="1" />
                <Tab label={translates.paymentMethod} value="2" />
                <Tab label={translates.ordersReopen} value="3" />
                {isFoodCompany && <Tab label={translates.changeTips} value="4" />}
              </TabList>
            </Stack>
            <Stack>
              <TabPanel value="1">
                <Stack height="100%" width="100%">
                  <Stack paddingLeft={3}>
                    <h2>{translates.history_transactions}</h2>
                  </Stack>
                  <Stack
                    maxHeight="30rem"
                    sx={{ overflowY: 'auto' }}
                    justifyContent="flex-start"
                    width="100%"
                  >
                    <CashRegisterTimeLine data={transactions?.data} />
                  </Stack>
                </Stack>
              </TabPanel>
              <TabPanel value="2">
                <Stack height="100%" width="100%">
                  <Stack marginLeft={3}>
                    <h2>{translates.history_payment_method}</h2>
                  </Stack>
                  <Stack
                    maxHeight="30rem"
                    sx={{ overflowY: 'auto' }}
                    justifyContent="flex-start"
                    width="100%"
                  >
                    <LogsPaymentMethodTimeLine id={currentId} />
                  </Stack>
                </Stack>
              </TabPanel>
              <TabPanel value="3">
                <Stack height="100%" width="100%">
                  <Stack marginLeft={3}>
                    <h2>{translates.history_re_open}</h2>
                  </Stack>
                  <Stack
                    maxHeight="30rem"
                    sx={{ overflowY: 'auto' }}
                    justifyContent="flex-start"
                    width="100%"
                  >
                    <LogsReOpenOrdersTimeLine id={currentId} />
                  </Stack>
                </Stack>
              </TabPanel>
              {isFoodCompany && (
                <TabPanel value="4">
                  <Stack height="100%" width="100%">
                    <Stack marginLeft={3}>
                      <h2>{translates.history_tips}</h2>
                    </Stack>
                    <Stack
                      maxHeight="30rem"
                      sx={{ overflowY: 'auto' }}
                      justifyContent="flex-start"
                      width="100%"
                    >
                      <LogsChangeTipsTimeLine id={currentId} />
                    </Stack>
                  </Stack>
                </TabPanel>
              )}
            </Stack>

            <Stack direction="column" spacing={2} marginX={3} marginTop={5}>
              {isOpen && (
                <>
                  <TransactionModal
                    isWithdrawal={false}
                    queryKey={[['transactions', 'findById', currentId]]}
                  />
                  <TransactionModal
                    isWithdrawal
                    queryKey={[['transactions', 'findById', currentId]]}
                  />
                </>
              )}
              <Chip
                onClick={handleClickOpen}
                color={isOpen ? 'error' : 'primary'}
                label={isOpen ? translates.turnClose : translates.turnOpen}
              />
            </Stack>

            {Component}
          </Card>
        </Grid>
      </Grid>
    </TabContext>
  );
}
